import './SummaryTable.scss';

import { IconAlertInfoOutlined } from '@hulu-react-style-components/icons';
import { bem } from 'mission-control-common-components';

import Tooltip from '../../../../../../../common/Tooltip';

const [block, element] = bem('summary-table');

export type TooltipInfo = {
  id: string;
  message: string;
  iconDataTestId: string;
};

export type SummaryTableHeader = {
  label: string;
  tooltipInfo?: TooltipInfo;
};

export type SummaryTableData = {
  value: string;
  tooltipInfo?: TooltipInfo;
};

type Props = {
  title: string;
  headers?: SummaryTableHeader[];
  data: SummaryTableData[][];
};

const SummaryTable = ({ title, headers, data }: Props): React.JSX.Element => {
  return (
    <div className={block()}>
      <div className={element('table-title')}>
        <p>{title}</p>
      </div>
      <div className={element('table-wrapper')}>
        <table>
          {headers && (
            <thead>
              <tr>
                {headers.map((header) => (
                  <th key={header.label}>
                    <div className={element('cell-content-wrapper')}>
                      <div>{header.label}</div>
                      {header.tooltipInfo && (
                        <Tooltip id={header.tooltipInfo.id} message={header.tooltipInfo.message} place="top">
                          <IconAlertInfoOutlined
                            className="info-icon"
                            aria-label={header.tooltipInfo.iconDataTestId}
                            data-testid={header.tooltipInfo.iconDataTestId}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {data.map((row, rowIdx) => (
              <tr key={`summary-table-row-${rowIdx}`}>
                {row.map((data, colIdx) => (
                  <td key={`${data.value}_${colIdx}`}>
                    <div className={element('cell-content-wrapper')}>
                      <div>{data.value}</div>
                      {data.tooltipInfo && (
                        <Tooltip id={data.tooltipInfo.id} message={data.tooltipInfo.message} place="top">
                          <IconAlertInfoOutlined
                            className="info-icon"
                            aria-label={data.tooltipInfo.iconDataTestId}
                            data-testid={data.tooltipInfo.iconDataTestId}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SummaryTable;
